import React from 'react'
import '../App.css';
import OurService from './OurService';
import {Fade, Zoom} from 'react-reveal'
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import AddTaskIcon from '@mui/icons-material/AddTask';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import './Service.css';
import our_program from '../assets/img/services/program.png'
import Incubation from '../assets/img/services/Incubation.png'
import design_thinking from '../assets/img/services/design-thinking.png'
export const Service = () => {
  return (
    <section className="service_wrapper container-fluid">
        <div className="container text-center">
          <Fade up> 
        <span className='subtitle'>Turn your Idea Into Reality</span>
        <h2>Workshop For Startup Founders </h2>
            </Fade>
            <Fade>

        <p className='text-dark m-auto w-75 pb-5'>
        A workshop designed with scientific and guaranteed approach to well acquaint individuals inspired by business venture, new companies and concerned authority is our forte. We offer not just a tailored session on topics like funding sources, marketing plans, networking, financial projections, leadership, entrepreneurship, and so on. Rather, after analyzing the existing circumstances of the concerned authority, we customize courses and help them ace their competency.
          </p>
            </Fade>
        <div className="row">
         
         <OurService title="Our Program" 
         serviceID = 'our-program'
         text="Entrepreneurial Research
         We focus on creating mature entrepreneurship innovation, well thought out workshops with fast turnaround times to ensure quick development at all stages- from our preferred method for young entrepreneurs and youths to create, manage and operate sustainable business ecosystems. 
         " icon={our_program}
         />
          
         <OurService title="Incubation " text="This Entrepreneurial Workshop is designed for both newcomers as well as seasoned entrepreneurs from all walks in life: startup founders, experienced venture capitalists and investment bankers who want to meet more startups (or investors) together at our  workshop sessions." 
         icon={Incubation}/>
          
         {/* <OurService title="Incubation " text="This Entrepreneurial Workshop is designed for both newcomers as well as seasoned entrepreneurs from all walks in life: startup founders, experienced venture capitalists and investment bankers who want to meet more startups (or investors) together at our  workshop sessions." icon="fa-solid fa-camera-rotate fa-flip m-auto my-3 ia fa-3x"/> */}
      
         <OurService title="Design Thinking"
         serviceID='design-thinking'
          text="We aim to walk with you from the fragile idea's generation stages to the advanced stage of execution of entrepreneurial ideas! Develop cognitive, strategic and practical processes for your startup ideas. " 
          icon={design_thinking} />
        </div>
        </div>
    </section>
  )
}
